import { last } from 'lodash'
import { Channel } from 'phoenix'
import { IframeContextState } from '../IframeConn'
import { NotificationsContextState } from '../Notifications'
import {
  convertChats,
  convertMessage,
  getLinks,
  // getCustomData,
  getUnreadAt,
  livechatEndMsg,
  livechatStartMsg,
} from './chatConverter'
import { notifyNewChat, notifyNewMessage } from './notification'
import {
  Chat,
  ChatRaw,
  Message,
  PoolCommand,
  PoolCommandChatNew,
  PoolCommandChatUpdate,
  SetChats,
} from './types'

const poolHandler = async (
  channel: Channel,
  commands: PoolCommand[],
  chatAccountId: number,
  queueId: number,
  chats: Chat[],
  setChats: SetChats,
  iframeContextState: IframeContextState,
  notificationsContextState: NotificationsContextState,
  activePauseSupervisorRef: React.MutableRefObject<boolean>,
  setActiveChatSupervisor: React.Dispatch<React.SetStateAction<boolean>>
) => {
  for (const command of commands) {
    if (command['chatId']) {
      // odeślij potwierdzenie
      channel.push('log', {
        id: command['chatId'],
        type: command.type,
        queueId,
      })
    }

    switch (command.type) {
      case 'UPDATE':
        handleUpdate(command, chats, setChats, notificationsContextState)
        break

      case 'NEW':
        await handleNew(
          command,
          chats,
          setChats,
          chatAccountId,
          iframeContextState,
          notificationsContextState
        )
        break

      case 'USER_TYPING':
        setChats(chats =>
          chats.map(chat =>
            chat.id != command.chatId ? chat : { ...chat, clientTyping: true }
          )
        )

        break

      case 'USER_TYPING_RESET':
        setChats(chats =>
          chats.map(chat =>
            chat.id != command.chatId ? chat : { ...chat, clientTyping: false }
          )
        )

        break

      case 'END':
        setChats(chats =>
          chats.map(chat =>
            chat.id != command.chatId
              ? chat
              : {
                  ...chat,
                  stopped: true,
                  clientTyping: false,
                  messages: [
                    ...chat.messages,
                    livechatEndMsg(last(chat.messages)!.unread),
                  ],
                }
          )
        )

        break

      case 'SUPER_ON':
        if (!activePauseSupervisorRef.current) {
          setActiveChatSupervisor(true)
        }
        break

      case 'SUPER_OFF':
        if (activePauseSupervisorRef.current) {
          setActiveChatSupervisor(false)
        }
        break
    }
  }
}

export default poolHandler

//

const addMessages = (
  chatId: string,
  messages: Message[],
  setChats: SetChats
) => {
  setChats(chats =>
    chats.map(chat =>
      chat.id != chatId
        ? chat
        : {
            ...chat,
            unread:
              chat.unread +
              messages
                .filter(message => message.unread)
                .filter(message => message.type == 'CLIENT').length,
            unreadAt: chat.unreadAt ? chat.unreadAt : getUnreadAt(messages),
            messages: [...chat.messages, ...messages],
            clientTyping: messages.find(m => m.type == 'CLIENT')
              ? false
              : chat.clientTyping,
          }
    )
  )
}

const setLinks = (chatRaw: ChatRaw, setChats: SetChats) => {
  setChats(chats =>
    chats.map(chat =>
      chat.id != chatRaw.chatId
        ? chat
        : {
            ...chat,
            links: getLinks(chatRaw),
          }
    )
  )
}

//

const handleUpdate = (
  command: PoolCommandChatUpdate,
  chats: Chat[],
  setChats: SetChats,
  notificationsContextState: NotificationsContextState
) => {
  const chat = chats.find(chat => chat.id == command.chatId)

  if (!chat) {
    console.error('chat not found ' + command.chatId)
    return
  }

  const messages = command.messages
    .map(message => convertMessage(message))
    .filter(message => message) as Message[]

  addMessages(command.chatId, messages, setChats)
  setLinks(command, setChats)

  notifyNewMessage(messages, chat, notificationsContextState)
}

const handleNew = async (
  command: PoolCommandChatNew,
  chats: Chat[],
  setChats: SetChats,
  chatAccountId: number,
  iframeContextState: IframeContextState,
  notificationsContextState: NotificationsContextState
) => {
  notifyNewChat(iframeContextState, notificationsContextState)

  const oldChat = chats.find(chat => chat.id == command.chatId)

  if (oldChat) {
    // sztuczne wiadomości mają queueid 0
    const lastMessage = last(oldChat.messages.filter(m => m.queueId))!

    const messages = command.messages
      .filter(message => message.queueId > lastMessage.queueId)
      .filter(message => message?.message != 'LIVECHAT_AFTER')
      .filter(message => message?.message != 'LIVECHAT_FAIL')
      .map(message => convertMessage(message))
      .filter(message => message) as Message[]

    setChats(
      chats.map(chat =>
        chat.id != oldChat.id
          ? chat
          : {
              ...chat,
              stopped: false,
            }
      )
    )

    messages.splice(
      messages.length - 1,
      0,
      livechatStartMsg(lastMessage.unread, lastMessage.sentAt)
    )

    addMessages(command.chatId, messages, setChats)
    setLinks(command, setChats)

    return
  }

  const [chat] = await convertChats([command], chatAccountId)

  if (!chats.length) {
    chat.active = true
  }

  setChats(chats => [...chats, chat])
}
